import { render, staticRenderFns } from "./card-carousel.vue?vue&type=template&id=39853d26&"
import script from "./card-carousel.vue?vue&type=script&lang=js&"
export * from "./card-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports